
export const get_payment_methods =(t) => {
    return [
        { label: t('Instrument not defined'), value: '1' },
        { label: t('Automated clearing house credit'), value: '2' },
        { label: t('Automated clearing house debit'), value: '3' },
        { label: t('ACH demand debit reversal'), value: '4' },
        { label: t('ACH demand credit reversal'), value: '5' },
        { label: t('ACH demand credit'), value: '6' },
        { label: t('ACH demand debit'), value: '7' },
        { label: t('Hold'), value: '8' },
        { label: t('National or regional clearing'), value: '9' },
        { label: t('In cash'), value: '10' },
        { label: t('ACH savings credit reversal'), value: '11' },
        { label: t('ACH savings debit reversal'), value: '12' },
        { label: t('ACH savings credit'), value: '13' },
        { label: t('ACH savings debit'), value: '14' },
        { label: t('Bookentry credit'), value: '15' },
        { label: t('Bookentry debit'), value: '16' },
        { label: t('ACH demand cash concentration/disbursement (CCD) credit'), value: '17' },
        { label: t('ACH demand cash concentration/disbursement (CCD) debit'), value: '18' },
        { label: t('ACH demand corporate trade payment (CTP) credit'), value: '19' },
        { label: t('Cheque'), value: '20' },
        { label: t('Banker\'s draft'), value: '21' },
        { label: t('Certified banker\'s draft'), value: '22' },
        { label: t('Bank cheque (issued by a banking or similar establishment)'), value: '23' },
        { label: t('Bill of exchange awaiting acceptance'), value: '24' },
        { label: t('Certified cheque'), value: '25' },
        { label: t('Local cheque'), value: '26' },
        { label: t('ACH demand corporate trade payment (CTP) debit'), value: '27' },
        { label: t('ACH demand corporate trade exchange (CTX) credit'), value: '28' },
        { label: t('ACH demand corporate trade exchange (CTX) debit'), value: '29' },
        { label: t('Credit transfer'), value: '30' },
        { label: t('Debit transfer'), value: '31' },
        { label: t('ACH demand cash concentration/disbursement plus (CCD+) credit'), value: '32' },
        { label: t('ACH demand cash concentration/disbursement plus (CCD+) debit'), value: '33' },
        { label: t('ACH prearranged payment and deposit (PPD)'), value: '34' },
        { label: t('ACH savings cash concentration/disbursement (CCD) credit'), value: '35' },
        { label: t('ACH savings cash concentration/disbursement (CCD) debit'), value: '36' },
        { label: t('ACH savings corporate trade payment (CTP) credit'), value: '37' },
        { label: t('ACH savings corporate trade payment (CTP) debit'), value: '38' },
        { label: t('ACH savings corporate trade exchange (CTX) credit'), value: '39' },
        { label: t('ACH savings corporate trade exchange (CTX) debit'), value: '40' },
        { label: t('ACH savings cash concentration/disbursement plus (CCD+) credit'), value: '41' },
        { label: t('Payment to bank account'), value: '42' },
        { label: t('ACH savings cash concentration/disbursement plus (CCD+) debit'), value: '43' },
        { label: t('Accepted bill of exchange'), value: '44' },
        { label: t('Referenced home-banking credit transfer'), value: '45' },
        { label: t('Interbank debit transfer'), value: '46' },
        { label: t('Home-banking debit transfer'), value: '47' },
        { label: t('Bank card'), value: '48' },
        { label: t('Direct debit'), value: '49' },
        { label: t('Payment by postgiro'), value: '50' },
        { label: t('FR, norme 6 97-Telereglement CFONB (French Organisation for Banking Standards) - Option A'), value: '51' },
        { label: t('Urgent commercial payment'), value: '52' },
        { label: t('Urgent Treasury Payment'), value: '53' },
        { label: t('Credit card'), value: '54' },
        { label: t('Debit card'), value: '55' },
        { label: t('Bankgiro'), value: '56' },
        { label: t('Standing agreement'), value: '57' },
        { label: t('SEPA credit transfer'), value: '58' },
        { label: t('SEPA direct debit'), value: '59' },
        { label: t('Promissory note'), value: '60' },
        { label: t('Promissory note signed by the debtor'), value: '61' },
        { label: t('Promissory note signed by the debtor and endorsed by a bank'), value: '62' },
        { label: t('Promissory note signed by the debtor and endorsed by a third party'), value: '63' },
        { label: t('Promissory note signed by a bank'), value: '64' },
        { label: t('Promissory note signed by a bank and endorsed by another bank'), value: '65' },
        { label: t('Promissory note signed by a third party'), value: '66' },
        { label: t('Promissory note signed by a third party and endorsed by a bank'), value: '67' },
        { label: t('Online payment service'), value: '68' },
        { label: t('Bill drawn by the creditor on the debtor'), value: '70' },
        { label: t('Bill drawn by the creditor on a bank'), value: '74' },
        { label: t('Bill drawn by the creditor, endorsed by another bank'), value: '75' },
        { label: t('Bill drawn by the creditor on a bank and endorsed by a third party'), value: '76' },
        { label: t('Bill drawn by the creditor on a third party'), value: '77' },
        { label: t('Bill drawn by creditor on third party, accepted and endorsed by bank'), value: '78' },
        { label: t('Not transferable banker\'s draft'), value: '91' },
        { label: t('Not transferable local cheque'), value: '92' },
        { label: t('Reference giro'), value: '93' },
        { label: t('Urgent giro'), value: '94' },
        { label: t('Free format giro'), value: '95' },
        { label: t('Requested method for payment was not used'), value: '96' },
        { label: t('Clearing between partners'), value: '97' },
        { label: t('Mutually defined'), value: 'ZZZ' }
    ];
}
